// Module
var code = "<template class=\"two-column-view\">\n    <div class=\"column column--first-column\">\n\t\t<slot name=\"first-column\"></slot>\n    </div>\n    <div class=\"column column--second-column\">\n        <slot name=\"second-column\"></slot>\n    </div>\n</template>\n";
// Exports
export default code;